import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useHistory } from "react-router-dom";
import {
  Dimmer,
  Icon,
  Input,
  Modal,
  ModalActions,
  Header,
  ModalContent,
  Button,
} from "semantic-ui-react";
import CONFIG from "config/config";
import UserLoginView from "issara-sdk/apis/UserLoginView_core";
import ErrorMessage from "react-lib/apps/common/ErrorMessage";
import ModConfirm from "react-lib/apps/common/cnmi/ModConfirm";

import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";

import {
  collection,
  getDocs,
  updateDoc,
  query,
  where,
  setDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";
import _ from "react-lib/compat/lodashplus";

import { firebaseApp, db } from "react-lib/frameworks/Firebase";
import { useIntl } from "react-intl";
import { is } from "date-fns/locale";
import TelepharDrugOrderOnlineListView from "issara-sdk/apis/TelepharDrugOrderOnlineListView_apps_TPD";
import TelepharDrugOrderUpdateCallStatus from "issara-sdk/apis/TelepharDrugOrderUpdateCallStatus_apps_TPD";
// chat_channel_id
// patient_id
// encounter_id
// division_id

export const Main = (props: any) => {
  const history = useHistory();
  const [firstTime, setFirstTime] = useState(true);
  const [iframeHeight, setIframeHeight] = useState(480);
  const [iframeWidth, setIframeWidth] = useState(640);
  const [visible, setVisible] = useState(true);
  const [videoCallStartPip, setVideoCallStartPip] = useState(false);
  const [openModConfirm, setOpenModConfirm] = useState(false);
  const [employeeUsername, setEmployeeUsername] = useState("");
  const [employeePwd, setEmployeePwd] = useState("");
  const [pwdError, setPwdError] = useState("");
  const [popupTitle, setPopupTitle] = useState("");
  const [waiting, setWaiting] = React.useState(false);
  const [waitingSkippable, setWaitingSkippable] = React.useState(false);
  const intl = useIntl();

  useEffect(() => {
    if (firstTime) {
      const _openVideoCallModal = localStorage.getItem("openVideoCallModal");
      const _videoCallRoom = localStorage.getItem("videoCallRoom");
      const _closeOverriding = localStorage.getItem("closeOverriding");
      setFirstTime(false);
      if (_openVideoCallModal === "true" && _videoCallRoom !== undefined) {
        props.setProp("openVideoCallModal", true);
        props.setProp("videoCallRoom", _videoCallRoom);
        props.setProp("closeOverriding", _closeOverriding);
      }
      if (_closeOverriding === "true" && _openVideoCallModal === "true") {
        setPopupTitle("กรุณารอการตอบรับจากเภสัชกร");
        setWaiting(true);
      }
    } else {
      setVisible(props.openVideoCallModal);
    }

    // Save to local storage
    localStorage.setItem("openVideoCallModal", props.openVideoCallModal);
    localStorage.setItem("closeOverriding", props.closeOverriding);
    localStorage.setItem("videoCallRoom", props.videoCallRoom);

    if (props.closeOverriding === true && props.openVideoCallModal) {
      setPopupTitle("กรุณารอการตอบรับจากเภสัชกร");
      setWaiting(true);
    }

    let u = props.userProfile ? props.userProfile?.username : "";
    setEmployeeUsername(u);
  }, [props.openVideoCallModal]);

  // const debounce = (fn:any, ms = 0) => {
  //   let timeoutId: number | undefined = undefined;
  //   return function(...args: any[]) {
  //     clearTimeout(timeoutId);
  //     timeoutId = setTimeout(() => fn.apply(this, args), ms);
  //   };
  // };

  const showCloseIcon = useMemo(() => {
    return waiting && !waitingSkippable && visible;
  }, [waiting, waitingSkippable, visible]);

  const updateDocBySessionId = async (
    sessionId: string,
    currChatChannelId: number,
    encounter_id: number,
    patient_id: number,
  ) => {
    console.log("ready with debouncing", currChatChannelId);
    // Query to find the document based on sessionId

    var chDetail,
      error,
      network = null;
    if (currChatChannelId) {
      [chDetail, error, network] = await props.chatController.getChannelDetail({
        chatChannelId: currChatChannelId,
        apiToken: props.apiToken,
      });
    }

    console.log("sessionId", sessionId);
    console.log("chDetail", chDetail);

    try {
      const q = query(collection(db, "webrtc_sessions"), where("sessionId", "==", sessionId));

      const querySnapshot = await getDocs(q);

      if (patient_id === undefined || patient_id === null) {
        if (chDetail) {
          patient_id = chDetail.owner;
        }
      }

      let updateObject = {
        href: window.location.href,
        referrer: window.location.href,
        username: props.userProfile ? props.userProfile?.username : "",
        channel_id: currChatChannelId ? currChatChannelId : "",
        patient_id: patient_id ? patient_id : "",
        encounter_id: encounter_id ? encounter_id : "",
        division_id: chDetail ? chDetail?.division : "",
        division_name: chDetail ? chDetail?.division_name : "",
        organization_code: chDetail ? chDetail?.organization_code : "",
        organization_name: chDetail ? chDetail?.organization_name : "",
      };

      Object.keys(updateObject).forEach((key) => {
        if (updateObject[key] === null || updateObject[key] === undefined) {
          updateObject[key] = "";
        }
      });

      console.log("updateObject", updateObject);

      if (!querySnapshot.empty) {
        // Update all documents with the same sessionId
        const updatePromises = querySnapshot.docs.map((doc) => {
          const docRef = doc.ref;

          return updateDoc(docRef, updateObject);
        });

        await Promise.all(updatePromises);

        console.log(`$updated successfully for all documents with the same sessionId.`);
      } else {
        // Document with sessionId does not exist, create a new document
        const newDocRef = doc(collection(db, "webrtc_sessions"));
        await setDoc(newDocRef, updateObject);
        console.log("New document created with the given sessionId.");
      }
    } catch (error) {
      console.error("Error updating or creating document:", error);
    }
  };

  const sendMessage = ({ contentType, content }: any = {}) => {
    return new Promise(async (resolve, reject) => {
      let txtContent = content;
      console.log("end_call to: ", props.currChatChannelId, txtContent);

      if (contentType !== "vid_call" && contentType !== "end_call" && !txtContent) {
        return;
      }
      if (!props.currChatChannelId) {
        return;
      }

      var response, error, network;
      [response, error, network] = await props.chatController.postChatChannelMessage({
        content: txtContent,
        contentFile: txtContent,
        contentType: contentType ? contentType : "text",
        chatChannelId: props.currChatChannelId,
        apiToken: props.apiToken,
        divisionId: props.division_id ? props.division_id : props.division,
      });
    });
  };

  const checkClosingOnCall = async () => {
    // call the API /apis/TPD/telephar/drug-order/online?consult_status=ON_CALL&code={props.videoCallRoom}
    return new Promise(async (resolve, reject) => {
      setPwdError("");

      const [result] = await TelepharDrugOrderOnlineListView.list({
        apiToken: props.apiToken,
        params: {
          consult_status: "ON_CALL",
        },
      });

      // item.consult_status === "ON_CALL"
      if (result && result.items && result.items.length > 0) {
        const onCallItem = result.items.find(
          (item: any) => item.code === props.videoCallRoom && item.consult_status === "ON_CALL",
        );
        console.log("props.videoCallRoom", props.videoCallRoom);
        console.log(result.items);
        console.log("checkClosingOnCall", onCallItem);

        if (onCallItem) {
          setPopupTitle(
            "ไม่สามารถปิดหน้าต่างได้ในขณะนี้ เนื่องจากเภสัชกรยังไม่เสร็จสิ้นการให้คำแนะนำ",
          );
          setWaiting(true);
          setWaitingSkippable(true);
          return true; // Found an item with ON_CALL status
        } else {
          setOpenModConfirm(true);
          setEmployeePwd("");
          setWaiting(false);
          setWaitingSkippable(false);
          return false; // No item with ON_CALL status found
        }
      }
    });
  };

  const checkAuth = () => {
    return new Promise(async (resolve, reject) => {
      setPwdError("");

      const [r, e, n] = await UserLoginView.post({
        apiToken: props.apiToken,
        data: { username: props.userProfile?.username, password: employeePwd },
      });

      setEmployeePwd("");
      if (r) {
        const [result] = await TelepharDrugOrderOnlineListView.list({
          apiToken: props.apiToken,
          params: {
            consult_status: "CALLING",
          },
        });

        const onCallItem = result.items.find(
          (item: any) => item.code === props.videoCallRoom && item.consult_status === "CALLING",
        );

        if (onCallItem) {
          await TelepharDrugOrderUpdateCallStatus.patch({
            apiToken: props.apiToken,
            pk: onCallItem.id,
            data: { consult_status: "IDLE" },
          });
        }

        handleClose();
        handleCloseVideoCall({ sendEndMessage: false });
      }
      if (e) {
        setPwdError(e);
      }
    });
  };

  const handleCloseVideoCall = ({ sendEndMessage = true }) => {
    console.log("MainVideoCall handle close video call");
    window.removeEventListener("message", handleIframeMessage);
    if (sendEndMessage) {
      setTimeout(() => {
        sendMessage({
          contentType: "end_call",
          content: props.videoCallRoom, // `${CONFIG.WEB_RTC}/${props.match.params.chatChannelId}/?name=${name}`
        });
      }, 1000);
    }

    localStorage.setItem("openVideoCallModal", "false");
    props.onClose?.();

    setVisible(false);
    setVideoCallStartPip(false);
    setIframeHeight(1);
    setIframeWidth(1);
  };

  const handleIframeResize = () => {
    setTimeout(() => {
      setIframeHeight(window.innerHeight - 100);
      setIframeWidth(window.innerWidth - 10);
      setVisible(true);
    }, 500);
  };

  const handleIframeMessage = (msg: any) => {
    try {
      let jsonMsg = JSON.parse(msg.data);
      console.log(msg);
      if (jsonMsg.message === "closeOverriding") {
        if (jsonMsg.users_count >= 1) {
          setPopupTitle(
            "ไม่สามารถปิดหน้าต่างได้ในขณะนี้ เนื่องจากเภสัชกรยังไม่เสร็จสิ้นการให้คำแนะนำ",
          );
          setWaiting(true);
          setWaitingSkippable(true);
        } else {
          checkClosingOnCall();
          // check the parmacist is confirm end the consultation
          // implement call async checkTelePharOnCall, then show the lock modal
        }
      } else if (jsonMsg.message === "end_call") {
        if (jsonMsg.users_count <= 1) {
          handleCloseVideoCall({ sendEndMessage: true });
        } else {
          handleCloseVideoCall({ sendEndMessage: false });
        }
      } else if (jsonMsg.message === "start_pip") {
        setTimeout(() => {
          setIframeHeight(1);
          setIframeWidth(1);
          setVideoCallStartPip(true);
          // setVisible(false);
        }, 500);
        window.removeEventListener("resize", handleIframeResize);
      } else if (jsonMsg.message === "stop_pip") {
        window.addEventListener("resize", handleIframeResize);
        setVideoCallStartPip(false);
        handleIframeResize();
      } else if (jsonMsg.message === "ready") {
        console.log("got ready message", props.videoCallRoom);
        debounceDocUpdate(
          props.videoCallRoom,
          props.currChatChannelId,
          props.encounter_id,
          props.patient_id,
        );
        // debounceDocUpdate(props.videoCallRoom)
        if (jsonMsg.users_count > 1) {
          setWaiting(false);
        }
      }
    } catch (e) {
      // ignore
    }
  };

  // const debounceDocUpdate = useCallback(
  //   _.debounce((roomId) => {
  //     updateDocBySessionId(roomId);
  //   }, 10000, { leading: false }),
  //   [props.currChatChannelId]
  // );

  const debounceDocUpdate = useCallback(
    _.debounce(
      (roomId, currChatChannelId, encounter_id, patient_id) => {
        console.log("encounter_id", encounter_id);
        console.log("username", props.username);
        console.log("patient_id", patient_id);
        updateDocBySessionId(roomId, currChatChannelId, encounter_id, patient_id);
      },
      10000,
      { leading: false },
    ),
    [props.currChatChannelId],
  );

  const onLoadIfrm = () => {
    window.addEventListener("resize", handleIframeResize);
    window.addEventListener("message", handleIframeMessage);
    if (visible) handleIframeResize();
  };

  const changeUsername = (data: any) => {
    setEmployeeUsername(data.value);
  };

  const changePassword = (data: any) => {
    setEmployeePwd(data.value);
  };

  const handleClose = () => {
    setOpenModConfirm(false);
  };

  return (
    <div>
      <ModConfirm
        openModal={!!openModConfirm}
        centered
        basic={false}
        modalStyle={{ width: "28%" }}
        titleName={intl.formatMessage({ id: "กรุณายืนยันสิทธิ์การปิดหน้าต่าง" })}
        size="small"
        // callback
        onCloseWithDimmerClick={handleClose}
        onClose={handleClose}
        // Element
        approveButton={
          <ButtonLoadCheck
            // function
            setProp={props.setProp}
            onClick={checkAuth}
            // data
            // paramKey={`${CARD_EXPORT_E_CLAIM_FILE}_${BUTTON_ACTIONS.SAVE}`}
            // buttonLoadCheck={
            //   props.buttonLoadCheck?.[
            //     `${CARD_EXPORT_E_CLAIM_FILE}_${BUTTON_ACTIONS.SAVE}`
            //   ]
            // }
            // config
            // disabled={!props.userTokenize?.employeeName}
            fluid={true}
            color={"green"}
            // name={BUTTON_ACTIONS.SAVE}
            size="medium"
            title={intl.formatMessage({ id: "ยืนยัน" })}
          />
        }
        // !!Note ใช่ onDeny เนื่องจากต้องการให้ปุ่มบันทึกอยู่ทางขวา
        denyButton={
          <ButtonLoadCheck
            // function
            setProp={props.setProp}
            onClick={handleClose}
            // data
            // paramKey={`${CARD_EXPORT_E_CLAIM_FILE}_${BUTTON_ACTIONS.SAVE}`}
            // buttonLoadCheck={
            //   props.buttonLoadCheck?.[
            //     `${CARD_EXPORT_E_CLAIM_FILE}_${BUTTON_ACTIONS.SAVE}`
            //   ]
            // }
            // config
            // disabled={!props.userTokenize?.employeeName}
            fluid={true}
            color={"red"}
            // name={BUTTON_ACTIONS.SAVE}
            size="medium"
            title={intl.formatMessage({ id: "ยกเลิก" })}
          />
        }
        content={
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              margin: "0 0 -1rem",
            }}
          >
            <div style={{ width: "90%", display: "flex", alignItems: "center" }}>
              <label style={{ marginRight: "2.5rem" }}>
                <strong>Username</strong>
                <span style={{ color: "red" }}>*</span>
              </label>
              <Input
                value={employeeUsername}
                onChange={(event, data) => changeUsername(data)}
                error={props.error}
                style={{ width: "100%" }}
              />
            </div>
            <div
              style={{
                width: "90%",
                display: "flex",
                alignItems: "center",
                marginTop: "1rem",
              }}
            >
              <label style={{ marginRight: "2.5rem" }}>
                <strong>Password</strong>
                <span style={{ color: "red" }}>*</span>
              </label>
              <Input
                type="password"
                value={employeePwd}
                onChange={(event, data) => changePassword(data)}
                onKeyDown={(e) => {
                  if (e.keyCode === 13) {
                    checkAuth();
                  }
                }}
                style={{ width: "100%" }}
              />
            </div>
            <ErrorMessage error={pwdError} style={{ width: "100%" }} />
          </div>
        }
      />

      {showCloseIcon && (
        <div
          style={{
            position: "fixed",
            top: "10px",
            right: "10px",
            zIndex: 1001,
          }}
        >
          <Button
            icon
            size="small"
            color="red"
            onClick={() => {
              checkClosingOnCall();
            }}
          >
            <Icon name="close" />
            <label style={{ marginLeft: "7px" }}>ปิดหน้าต่าง</label>
          </Button>
        </div>
      )}

      <Modal
        basic
        // onClose={() => setWaiting(false)}
        open={waiting}
        size="small"
      >
        <Header icon>
          <Icon name="call square" />
          {popupTitle}
        </Header>
        <ModalContent>
          <p></p>
        </ModalContent>
        <ModalActions>
          {/* show button only if waitingSkippable is true */}
          {waitingSkippable && (
            <Button
              color="green"
              inverted
              onClick={() => {
                setWaiting(false);
                setWaitingSkippable(false);
              }}
            >
              <Icon name="checkmark" /> Ok
            </Button>
          )}
        </ModalActions>
      </Modal>

      {props.openVideoCallModal && (
        <Dimmer
          inverted
          active={visible}
          size="fullscreen"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.0)",
            width: videoCallStartPip ? "0px" : "100%",
            height: videoCallStartPip ? "0px" : "100%",
          }}
          className={{}}
        >
          <iframe
            title={`${props.videoCallRoom}`}
            frameBorder={0}
            onLoad={onLoadIfrm}
            scrolling="no"
            allow="microphone; camera *; display-capture *;"
            src={`${CONFIG.WEB_RTC}/${props.videoCallRoom}/?name=${props.username}&
                  isPatient=${props.isPatient}&closeOverriding=${props.closeOverriding}`}
            // src={`http://localhost:3001/${props.videoCallRoom}/?name=${props.username}&
            //       isPatient=${props.isPatient}&closeOverriding=${props.closeOverriding}`}
            width={videoCallStartPip ? "1px" : iframeWidth}
            height={videoCallStartPip ? "1px" : iframeHeight}
          />
        </Dimmer>
      )}
    </div>
  );
};
